<template>
    <div>
        <div id="contribute-pie"></div>
        <div class="seach_clty">
            <div class="pick_title">体验间建设排名</div>
            <div class="pick_warp">
                <div :class="[nCity == index?'atv_pick':'']" v-for="(item,index) in arrCity" :key="index" @click="changeType(index,item.id)">{{item.name}}</div>
            </div>
        </div>
        <!-- 列表 -->
        <div class="tabel">
            <div class="biao_tb">
                <div :style="{width:(1/titleList.length).toFixed(2)*100 + '%'}" v-for="(item,index) in titleList" :key="index">{{item}}</div>
            </div>
            <div class="biao_th" :style="{height:item.filter(i=>i.length>5).length ==0?'39px':'95px'}" v-for="(item,index) in tableData" :key="index">
                <div :style="{width:(1/titleList.length).toFixed(2)*100 + '%'}" v-for=" (i, index1) in item" :key="index1">{{i}}</div>
            </div>
        </div>
        <div class="page-wrap">
            <el-performance :page="nPage" :nNumber="nTotal" @next="next" @last="last" @active="getActive" :bBackfoued="false"></el-performance>
        </div>
        <div class="bottom_btn" @click="getReportRankExport">一键导出</div>
    </div>
</template>

<script>
import elPerformance from "@/components/common/pagination/index.vue";
import resultRequest from '@/js/hvac/performance/result.js'
import { fetchVerifyAuthForB} from '@/libsV2/havc.js'
export default {
    data() {
        return {
            nCity: 0,
            arrCity: [
                {name:"城市",id:0},
                {name:"大区",id:4},
                {name:"代理商",id:1},
            ],
            contributePieData: [],
            tableData:[],//表格数据
            nPage: 1,
            nTotal: 0,
            start_at:"2021-01-01",
            end_at: this.newDate(1),
            page: 0,
            limit: 5,
            rank_type:3,
            type:0,
            titleList:[],
            NumData:{},

            times: '',    // 定时器
        };
    },
    components: {
        elPerformance
    },
    mounted() {
        if(!this.currentData.start_at) {
            this.currentData.start_at = '2021-01-01';
            this.currentData.end_at = this.newDate(0);
        }
        fetchVerifyAuthForB(() => {
            this.getReportStatistics(this.currentData)
            this.getReportRank('city');

            this.times = setInterval(() => {  // 定时更新数据
                this.getReportStatistics(this.currentData)
                this.getReportRank();
            }, 1000 * 60 * 5);
        })
    },
    props:['currentdate'],
    methods: {
        getReportRankExport() {
             const { start_at, end_at } = this.currentData;
            resultRequest.getportExcel({ end_at, start_at }).then( res => {
                console.log(res.data.data.result.url);
                window.location.href = res.data.data.result.url;
                // window.open(res.data.data.result.url, '_blank');
            })
        },
        changeType (index,id) {
            this.nPage = 1;
            this.page = 0;

            this.type = id
            this.nCity = index
            this.getReportRank()
        },
        textState(index) {
            if (index == 0) {
                return 'city'
            } else if (index == 1 ) {
                return 'company'
            } else {
                return 'area'
            }
        },
        createContributePie() {
            const CHARTS = this.$echarts.init(
                document.getElementById("contribute-pie")
            );
            if(this.contributePieData.length == 0) {
                this.contributePieData = [0];
                var colorBg = ["#F1F1F1"];
            }else {
                var colorBg = [
                    "rgba(91, 143, 249, 0.85)",
                    "rgba(90, 216, 166, 0.85)",
                    "rgba(93, 112, 146, 0.85)",
                    "rgba(246, 189, 22, 0.85)",
                    "rgba(232, 104, 74, 0.85)",
                ];
            }

            let start_time = '';
            let end_time = '';
            if(!this.currentData.start_at) {
                start_time = '2021-01-01';
                end_time = this.newDate(0);
            }else {
                const { start_at, end_at } = this.currentData;
                start_time = start_at;
                end_time = end_at;
            }
            const OPTIONS = {
                title: {
                    text: `${start_time} ~ ${end_time}`,
                    left: 'center',
                    top: 18,
                    textStyle: {
                        color: "#999999",
                        fontSize: 12
                    }
                },
                tooltip: {
                    trigger: "item",
                },
                color: colorBg,
                series: [
                    {
                        name: "Access From",
                        type: "pie",
                        radius: ["40%", "60%"],
                        center: ["50%", "50%"],
                        avoidLabelOverlap: true,

                        data: [{}],
                        label: {
                            normal: {
                                show: true,
                                position: "center",
                                color: "#4c4a4a",
                                formatter:
                                    "{count|" +
                                    this.NumData.room +
                                    "}" +
                                    "\n\r" +
                                     "{title|竣工体验间}",
                                rich: {
                                    count: {
                                        fontSize: 36,
                                        fontFamily: "微软雅黑",
                                        color: "#000000",
                                    },
                                    title: {
                                        fontFamily: "微软雅黑",
                                        fontSize: 16,
                                        color: "#858585",
                                        lineHeight: 30,
                                    },
                                },
                            },
                            emphasis: {
                                //中间文字显示
                                show: true,
                            },
                        },
                    },
                    {
                        name: "Access From",
                        type: "pie",
                        radius: ["40%", "60%"],
                        center: ["50%", "50%"],
                        avoidLabelOverlap: true,

                        data: this.contributePieData,
                        itemStyle: {
                            normal: {
                                label: {
                                    show: true,
                                    position: "outside",
                                    textStyle: {
                                        color: "#858585",
                                        fontWeight: 200,
                                        fontSize: 12,
                                    },
                                    formatter: function (p) {
                                        return p.name + "\n" + p.percent + "%";
                                    },
                                },
                                labelLine: {
                                    //指示线状态
                                    show: true,
                                    length: 10,
                                    length2: 12,
                                },
                            },
                        },
                    },
                ],
            };
            CHARTS.setOption(OPTIONS);
        },
        next(val) {// 上一页
            this.nPage = val;
            this.page = val - 1;
            this.getReportRank();
        },
        last(val) {// 下一页
            this.nPage = val;
            this.page = val - 1;
            this.getReportRank();
        },
        getActive(val) {
            this.nPage = val;
            this.page = val - 1;
            this.getReportRank();
        },

         /**
         *根据数据条数与每页多少条数据计算页数 
        * totalnum 数据条数
        * limit 每页多少条
        */
        pageCount(totalnum, limit) {
            return totalnum > 0 ? ((totalnum < limit) ? 1 : ((totalnum % limit) ? (parseInt(totalnum / limit) + 1) : (
                totalnum / limit))) : 0;
        },
        // 获取洽谈统计数据
        getReportStatistics (obj) {
            const options = {
                ...obj,
                time_type:2,
                compare_type:1
            }
            resultRequest.getReportStatistics(options).then( res => {
                const result = res.data.data.result
                this.NumData = {
                    room:result.project.total,
                    user:result.user,
                    contract:(result.user/result.contract).toFixed(2) + '%'
                }
                if (result.contract == 0 ) {
                    this.NumData.contract = '0%'
                }
                let list = []
                result.project.list.forEach(item => {
                    let obj = {
                        value:item.num,
                        name:item.area_name
                    }
                    list.push(obj)
                })
                this.contributePieData = list;

                this.createContributePie();
            })
        },
        newDate(i) {
            const nowdate = Date.parse(new Date())
            let newDate = new Date(nowdate - 60*60*24*1000*i);
            const year = newDate.getFullYear();
            let month = newDate.getMonth() + 1;
            let date = newDate.getDate();
            month = (month < 10) ? '0' + month : month
            date = (date < 10) ? '0' + date : date
            const time = year + '-' + month + '-' + date
            return time
        },
        // 获取洽谈排名数据
        getReportRank () {
            this.tableData = [];
            let styArr = this.textState(this.type);
            const options = {
                ...this.currentData,
                page:this.page,
                limit:this.limit,
                rank_type:this.rank_type,
                type:this.type
            }
            resultRequest.getReportRank(options).then( res => {
                const result = res.data.data.result;
                this.tableData = result.list
                this.nTotal = this.pageCount(result.total, this.limit);
                this.titleList = result.title
            })
        },
    },
    computed:{
        currentData () {
            return this.$store.state.performanceExperience.currentData
        }
    },
    watch:{
        currentData: {
            handler (newObj,oldObj) {
                this.getReportStatistics(newObj);
                this.changeType(0, 0);
            },
            immediate:false,
        },
    },
    beforeDestroy () { //在vue实例销毁前，清除定时器
         if (this.times) {
            clearInterval(this.times);
        }
    }
};
</script>

<style lang="scss" scoped>
#contribute-pie {
    width: 100%;
    height: 680px;
}
.bottom_btn {
    width: 100%;
    border-radius: 12px;
    background: linear-gradient(136deg, #4ea062 0%, #338444 100%);
    height: 92px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 28px;
    margin-top: 32px;
}
.tabel {
    width: 100%;
    border: 2px solid #e1e1e1;
    margin-top: 62px;
    .biao_th {
        width: 100%;
        // height: 80px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #e1e1e1;
        div {
            color: #318544;
            height: 100%;
            font-size: 28px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-right: 1px solid #e1e1e1;

            padding: 10px;
            box-sizing: border-box;
            &:last-child {
                border-right: 0;
            }
            span {
                display: flex;
                flex: 1;
                height: 100%;
                align-items: center;
                justify-content: center;
                border-right: 1px solid #e1e1e1;
                &:last-child {
                    border-right: 0;
                }
            }
        }
    }
    .biao_tb {
        width: 100%;
        height: 80px;
        background: #f0f4f1;
        display: flex;
        align-items: center;
        div {
            color: #318544;
            height: 100%;
            font-size: 28px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-right: 1px solid #e1e1e1;
            &:last-child {
                border-right: 0;
            }
        }
    }
}
.seach_clty {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 22px;
    margin-top: 28px;
    border-top: 2px dashed #f1f1f1;
    .pick_title {
        color: #318544;
        font-size: 28px;
        font-weight: 700;
    }
    .pick {
        width: 170px;
        height: 64px;
        background: #318544;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 24px;
        position: relative;
        &::after {
            content: "";
            display: flex;
            width: 28px;
            height: 28px;
            background: url("~@/assets/images/ant/back_icon_opiten.png")
                no-repeat center/100% 100%;
            // position: absolute;
            // right: 12px;
            margin-left: 12px;
        }
    }
    .pick_warp {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 330px;
        height: 64px;
        border-radius: 12px;
        border: 2px solid #dbdbdb;
        div {
            width: 33.33%;
            font-size: 24px;
            color: #c2c2c2;
            border-right: 1px solid #f1f1f1;
            display: flex;
            align-items: center;
            justify-content: center;
            &:last-child {
                border: 0;
            }
        }
        .atv_pick {
            color: $deepGreen;
        }
    }
}
.page-wrap {
    margin: 0 auto;
    margin-top: 24px;
    overflow: hidden;
}
</style>